import React, { ReactElement } from "react";
import cx from "classnames";

export function Card({
  children,
  className,
  noPadding,
  notFull,
  noMargin,
}: {
  children: ReactElement;
  className?: string;
  noPadding?: boolean;
  notFull?: boolean;
  noMargin?: boolean;
  noRounding?: boolean;
}) {
  return (
    <div
      className={cx(
        "card bg-base-100 rounded-md",
        noMargin ? "mb-0" : "mb-8",
        notFull ? "" : "w-full",
        className
      )}
    >
      <div className={cx("card-body", noPadding && " p-0")}>{children}</div>
    </div>
  );
}
